/**
 * Created by jobou on 07/01/17.
 */

export { PaginationComponent } from './pagination.component';



// WEBPACK FOOTER //
// ./src/app/common/pagination/index.ts